/*
 Initializations and settings for the Capture Widget.

 For more information about these settings, see the following documents:

 http://developers.janrain.com/documentation/widgets/social-sign-in-widget/social-sign-in-widget-api/settings/
 http://developers.janrain.com/documentation/widgets/user-registration-widget/capture-widget-api/settings/
 */

// Accessibility: when opening the modal, set all other content on the page to aria-hidden, so that screenreaders can't access them anymore.
let $A11YElements;

(function () {
  // Check for settings. If there are none, create them
  if (typeof window.janrain !== 'object') {
    window.janrain = {};
  }
  if (typeof window.janrain.settings !== 'object') {
    window.janrain.settings = {};
  }
  if (typeof window.janrain.settings.capture !== 'object') {
    window.janrain.settings.capture = {};
  }

  // Load Engage and Capture. 'login' is Engage, 'capture' is Capture.
  // Changing these values without guidance can result in unexpected behavior.
  janrain.settings.packages = ['login', 'capture'];

  /*--- Application Settings -----------------------------------------------*\

     When transitioning from a development to production, these are the
     settings that need to be changed. Others may also need to be changed if
     you have purchased optional products and features, such as Federate.
     Those settings are located below.

     janrain.settings.appUrl:
     The URL of your Engage application.
     Example: https://your-company.rpxnow.com

     janrain.settings.capture.captureServer:
     The URL of your Capture application.
     Example: https://your-company.janraincapture.com

     janrain.settings.capture.appId:
     The the application ID of your Capture application.

     janrain.settings.capture.clientId:
     The client ID of the Capture application.

     Example Dev Configuration:
     janrain.settings.appUrl                = 'https://your-company-dev.rpxnow.com';
     janrain.settings.capture.captureServer = 'https://your-company-dev.janraincapture.com';
     janrain.settings.capture.appId         = <DEV CAPTURE APP ID>;
     janrain.settings.capture.clientId      = <DEV CAPTURE CLIENT ID>;
     var httpLoadUrl                        = "http://widget-cdn.rpxnow.com/load/your-company-dev";
     var httpsLoadUrl                       = "https://rpxnow.com/load/your-company-dev";

     Example Prod Configuration:
     janrain.settings.appUrl                = 'https://login.yourcompany.com';
     janrain.settings.capture.captureServer = 'https://your-company.janraincapture.com';
     janrain.settings.capture.appId         = <PROD CAPTURE APP ID>;
     janrain.settings.capture.clientId      = <PROD CAPTURE CLIENT ID>;
     var httpLoadUrl                        = "http://widget-cdn.rpxnow.com/load/login.yourcompany.com";
     var httpsLoadUrl                       = "https://rpxnow.com/load/login.yourcompany.com";

     \*------------------------------------------------------------------------*/

  janrain.settings.appUrl = LOGIN.config.appUrl;
  janrain.settings.capture.captureServer = LOGIN.config.captureServer;
  janrain.settings.capture.appId = LOGIN.config.appId;
  janrain.settings.capture.clientId = LOGIN.config.clientId;
  janrain.settings.capture.recaptchaUrl = LOGIN.config.recaptchaUrl;
  janrain.settings.capture.recaptchaVersion = LOGIN.config.recaptchaVersion;

  // These are the URLs for your Engage app's load.js file, which is necessary
  // to load the Capture Widget.
  let httpLoadUrl = LOGIN.config.httpLoadUrl;
  let httpsLoadUrl = LOGIN.config.httpsLoadUrl;

  // --- Engage Widget Settings ----------------------------------------------
  janrain.settings.language = 'de-DE';

  janrain.settings.tokenUrl = window.location.href;
  janrain.settings.tokenAction = 'event';
  janrain.settings.showAttribution = false;
  janrain.settings.borderColor = '#ffffff';
  janrain.settings.fontFamily = 'Helvetica, Lucida Grande, Verdana, sans-serif';
  janrain.settings.width = 300;
  janrain.settings.actionText = ' ';

  // --- Capture Widget Settings ---------------------------------------------
  janrain.settings.capture.redirectUri = window.location.href
    .replace(window.location.hash, '')
    .replace('#', '');
  janrain.settings.capture.flowName = 'standard';
  janrain.settings.capture.flowVersion = 'HEAD';
  janrain.settings.capture.registerFlow = 'socialRegistration';
  janrain.settings.capture.setProfileCookie = true;
  janrain.settings.capture.keepProfileCookieAfterLogout = true;
  janrain.settings.capture.modalCloseHtml =
    '<svg width="20" height="20" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M1,1 L15,15 M15,1 L1,15" stroke="#6B6960" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  janrain.settings.capture.noModalBorderInlineCss = true;
  janrain.settings.capture.responseType = 'token';
  janrain.settings.capture.returnExperienceUserData = ['displayName', 'email'];
  janrain.settings.capture.stylesheets = [LOGIN.config.stylesheetUrl];

  // iOS blocks Popups, so we switch to another (popup free) method of authentication
  if ($('body').data('representation') !== 'web') {
    janrain.settings.popup = false;
    janrain.settings.tokenAction = 'url';
    janrain.settings.type = 'embed';
    janrain.settings.redirectUri = location.href; // required.
    janrain.settings.capture.redirectFlow = true;
  }

  // --- BEGIN WIDGET INJECTION CODE -----------------------------------------
  /********* WARNING: *******************************************************\
     |      DO NOT EDIT THIS SECTION                                            |
     | This code injects the Capture Widget. Modifying this code can cause the  |
     | Widget to load incorrectly or not at all.                                |
     \**************************************************************************/

  function isReady() {
    janrain.ready = true;
  }
  $(document).ready(function () {
    isReady();
  });

  let injector = document.createElement('script');
  injector.type = 'text/javascript';
  injector.id = 'janrainAuthWidget';
  if (document.location.protocol === 'https:') {
    injector.src = httpsLoadUrl;
  } else {
    injector.src = httpLoadUrl;
  }
  let firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(injector, firstScript);

  // --- END WIDGET INJECTION CODE -------------------------------------------
})();

// This function is called by the Capture Widget when it has completred loading
// itself and all other dependencies. This function is required, and must call
// janrain.capture.ui.start() for the Widget to initialize correctly.
function janrainCaptureWidgetOnLoad() {
  let implFuncs = janrainImplementationFunctions(); // Located below.

  /*==== CUSTOM ONLOAD CODE START ==========================================*\
     ||  Any javascript that needs to be run before screens are rendered but   ||
     ||  after the Widget is loaded should go between this comment and "CUSTOM ||
     ||  ONLOAD CODE END" below.                                               ||
     \*                                                                        */

  /*--
     SCREEN TO RENDER:
     This setting defines which screen to render. We've set it to the result
     of implFuncs.getParameterByName() so that if you pass in a parameter
     in your URL called 'screenToRender' and provide a valid screen name,
     that screen will be shown when the Widget loads.
     --*/
  janrain.settings.capture.screenToRender =
    implFuncs.getParameterByName('screenToRender');

  /*--
     EVENT HANDLING:

     Event Documentation:
     http://developers.janrain.com/reference/javascript-api/registration-js-api/events/
     --*/
  janrain.events.onCaptureScreenShow.addHandler(
    implFuncs.enhanceReturnExperience
  );
  janrain.events.onCaptureSaveSuccess.addHandler(implFuncs.hideResendLink);

  /*--
     NAVIGATION EVENTS:
     These event handlers are used for navigating the example implementation
     that exists on our servers for testing/demo/sample purposes. It is not
     required for your implementation, but can be modified to suit your
     needs. These event handlers are provided as an example.
     --*/
  janrain.events.onModalOpen.addHandler(implFuncs.modalOpen);
  janrain.events.onModalClose.addHandler(implFuncs.modalClose);
  janrain.events.onCustomizationChange.addHandler(
    implFuncs.customizationChange
  );
  janrain.events.onCaptureLoginSuccess.addHandler(
    implFuncs.setNavigationForLoggedInUser
  );
  janrain.events.onCaptureSessionFound.addHandler(
    implFuncs.updateUserInformation
  );
  janrain.events.onCaptureRegistrationSuccess.addHandler(
    implFuncs.sendActivationSms
  );
  janrain.events.onCaptureSessionEnded.addHandler(
    implFuncs.setNavigationForLoggedOutUser
  );
  janrain.events.onCaptureLoginFailed.addHandler(
    implFuncs.handleDeactivatedAccountLogin
  );
  janrain.events.onCaptureAccountDeactivateSuccess.addHandler(
    implFuncs.handleAccountDeactivation
  );
  janrain.events.onCaptureAccessDenied.addHandler(implFuncs.handleAccessDenied);
  janrain.events.onCaptureRegistrationFailed.addHandler(
    implFuncs.handleRegistrationFailure
  );
  janrain.events.onCaptureProfileSaveFailed.addHandler(
    implFuncs.handleRegistrationFailure
  );
  janrain.events.onCaptureProfileSaveSuccess.addHandler(
    implFuncs.handleAccountSaved
  );
  janrain.events.onCaptureFormError.addHandler(implFuncs.handleFormError);
  janrain.events.onCaptureContentChange.addHandler(
    implFuncs.handleCaptureContentChange
  );

  /*--
     SHOW EVENTS:
     Uncomment this line to show events in your browser's console. You must
     include janrain-utils.js to run this function.
     --*/
  // janrainUtilityFunctions().showEvents();

  /*--
     SHOW FLOW VERSION:
     This event handler shows the flow version in the specified element.
     This is primarily for our developers' convenience, but your developers
     may also find it useful.
     --*/

  /* janrain.events.onCaptureRenderStart.addHandler(function(result) {
        implFuncs.showFlowVersion('flow-version', result);
    }); */

  janrain.capture.ui.registerFunction(
    'validateFieldName',
    implFuncs.validateFieldName
  );

  /*                                                                        *\
     || *** CUSTOM ONLOAD CODE END ***                                         ||
     \*========================================================================*/

  // This should be the last line in janrainCaptureWidgetOnLoad()
  janrain.capture.ui.start();
}
window.janrainCaptureWidgetOnLoad = janrainCaptureWidgetOnLoad;
// Reference implementation navigation.
function janrainImplementationFunctions() {
  function modalOpen(result) {
    $('#janrainModalOverlay').click(function () {
      janrain.capture.ui.modal.close();
    });

    // accessibility
    $A11YElements = $('#janrainModal')
      .siblings('header, main, div, section, footer, span, h1, a, img')
      .not('[aria-hidden=true]') // don't touch elements that have aria-hidden=true already set!
      .filter((i, el) => el.style.display !== 'none'); // elements are usually hidden for a purpose, e.g. all different screens of janrain's modal flow

    $A11YElements.attr({
      'aria-hidden': true,
      role: 'presentation',
    });

    setTimeout(function () {
      $('#janrain-modal__skiplink-target')
        .attr('tabindex', -1)
        .on('blur focusout', function () {
          $(this).removeAttr('tabindex');
        })
        .focus();

      $('#janrain-facebook').removeAttr('role');
      $('#janrain-twitter').removeAttr('role');
    }, 500);

    if ($(window).width() < 720) {
      $('#janrainModal').css({ width: $(window).width() + 'px', padding: '0' });
      $('#janrainModal').addClass('js-janrain-mobile');
    } else {
      $('#janrainModal').css({ 'max-height': '80vh' });
    }
    $('html').addClass('modal--opened');
  }
  function modalClose(result) {
    if ($(window).width() < 1024) {
      window.scrollTo(0, $('#srf-comments').offset().top);
    }

    $('html').removeClass('modal--opened');

    // accessibility
    $A11YElements.removeAttr('aria-hidden').removeAttr('role');
    $('*[data-janrain-opening-link]')
      .attr('tabindex', -1)
      .on('blur focusout', function () {
        $(this).removeAttr('tabindex');
      })
      .focus();
  }
  function customizationChange(result) {
    if ($('.janrain_modal_closebuttontext').length === 0) {
      $('.janrain_modal_closebutton').append(
        '<p class="h-offscreen janrain_modal_closebuttontext">Schliessen</p>'
      );
    }

    if ($('#janrain-modal__skiplink-target').length === 0) {
      $('#janrainModal').prepend(
        '<span id="janrain-modal__skiplink-target" class="h-offscreen">Login Fenster</span>'
      );
    }

    $('#janrainModal').find('a[tabindex]').removeAttr('tabindex');
  }
  function setNavigationForLoggedInUser() {
    janrain.capture.ui.modal.close();
    $(document).trigger('login:check');
  }

  function updateUserInformation() {
    $(document).trigger('session:found');
  }

  function sendActivationSms() {
    $(document).trigger('login:check');
  }
  function setNavigationForLoggedOutUser() {
    $(document).trigger('login:logout');
  }
  function handleAccessDenied() {
    $(document).trigger('login:denied');
  }
  function handleRegistrationFailure(result) {
    if (
      result.statusMessage === 'validationErrors' ||
      result.statusMessage === 'invalidInput'
    ) {
      $(document).trigger('validation:failure');
    }
  }
  function getParameterByName(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  function enhanceReturnExperience(result) {
    if (result.screen == 'returnTraditional') {
      let span = document.getElementById(
        'capture_returnTraditional_signInEmailAddress'
      );
      let email = janrain.capture.ui.getReturnExperienceData('email');
      if (span && email) {
        span.value = email;
      }
    }
  }
  function hideResendLink(result) {
    // Hide the 'Resend confirmation email' link if it's been clicked
    // from the edit profile page. Link will reappear if the user
    // refreshes their profile page.
    if (
      result.controlName == 'resendVerificationEmail' &&
      result.screen == 'editProfile'
    ) {
      document.getElementById('capture_editProfile_resendLink').style.display =
        'none';
    }
  }
  function handleDeactivatedAccountLogin(result) {
    if (result.statusMessage == 'accountDeactivated') {
      janrain.capture.ui.renderScreen('accountDeactivated');
    }
  }
  function handleAccountDeactivation(result) {
    if (result.status == 'success') {
      document.getElementById('editProfile').style.display = 'none';
      janrain.capture.ui.modal.close();
      janrain.capture.ui.endCaptureSession();
      janrain.capture.ui.renderScreen('accountDeactivated');
    }
  }
  function showFlowVersion(elementId, result) {
    let elem = document.getElementById(elementId);
    elem.innerText = 'Flow version: ' + result.version;
  }
  function handleAccountSaved(result) {
    if (result.status == 'success') {
      $(document).trigger('profile:saved');
    }
  }
  function handleFormError(result) {
    if ($('#capture_forgotPassword_forgotPasswordForm_errorMessages').length) {
      setTimeout(() => {
        $('#capture_forgotPassword_forgotPasswordForm_errorMessages').hide();
        $('#capture_forgotPassword_forgotPasswordForm')
          .find('.capture_tip_error')
          .text(result.invalidIdentifier)
          .show();
        $('#capture_forgotPassword_form_item_signInEmailAddress').addClass(
          'capture_error'
        );
      }, 'fast');
    }
  }

  /**
   * fixes the jump out of focus problem, after clicking recaptcha on mobile
   */
  function handleCaptureContentChange() {
    // flying focus position has to be adjusted because of validation messages
    $(document).trigger('flyingfocus:move');

    const janrainModal = $('#janrainModal');
    const distanceToTop = $(window).scrollTop();
    const janrainModalHeight = janrainModal.height();
    const isJanrainModalOutOfViewport = distanceToTop > janrainModalHeight;
    const isJanrainModalVisible = janrainModal.css('display') === 'block';
    const isMobile = $(window).width() < 720;

    // scroll to top of window to make sure that the janrain modal is visible on mobile
    if (isMobile && isJanrainModalVisible && isJanrainModalOutOfViewport) {
      setTimeout(() => {
        $('html, body').animate(
          { scrollTop: janrainModalHeight - $(window).height() },
          0
        );
      }, 500);
    }
  }

  function validateFieldName(name, value) {
    let patternSpecialChars =
      /[\d&+»*%&/()=?!£$:;,§<>@±“#\[\]|{}≠¿∑€®†Ω§‘¶¬∆ºª¥≈©√∫~µ«…]/g;
    let isValid = true;

    // Invalid if shorter than two chars
    if (value.length < 2) {
      isValid = false;
    }

    // Invalid if first two chars are not a-z
    if (value.charAt(0) === '.' || value.charAt(1) === '.') {
      isValid = false;
    }

    // Invalid if special chars are in the name
    if (value.match(patternSpecialChars)) {
      isValid = false;
    }

    return isValid;
  }

  return {
    modalOpen: modalOpen,
    modalClose: modalClose,
    customizationChange: customizationChange,
    setNavigationForLoggedInUser: setNavigationForLoggedInUser,
    updateUserInformation: updateUserInformation,
    sendActivationSms: sendActivationSms,
    setNavigationForLoggedOutUser: setNavigationForLoggedOutUser,
    getParameterByName: getParameterByName,
    enhanceReturnExperience: enhanceReturnExperience,
    hideResendLink: hideResendLink,
    handleDeactivatedAccountLogin: handleDeactivatedAccountLogin,
    handleAccountDeactivation: handleAccountDeactivation,
    showFlowVersion: showFlowVersion,
    handleAccessDenied: handleAccessDenied,
    handleRegistrationFailure: handleRegistrationFailure,
    handleAccountSaved: handleAccountSaved,
    handleFormError: handleFormError,
    handleCaptureContentChange: handleCaptureContentChange,
    validateFieldName: validateFieldName,
  };
}
